import React from "react";
import chatPerson from "../../../images/img/chat-person.png";
import A1IMGPopup from "./A1IMGPopup";
import "./A1IMG.css";

const getButton = (button, fallbackLabel, fallbackValue, itemCode) => {
  const sourceLabel =
    button?.label || button?.text || button?.name || fallbackLabel;

  return {
    label: sourceLabel,
    sourceLabel,
    value: button?.value ?? button?.data ?? button?.payload ?? fallbackValue,
    code: button?.code || itemCode,
    tag: button?.uiCommand,
    url: button?.url,
  };
};

const getBackendContent = (item) => {
  if (item?.text_data) return item.text_data;
  if (item?.data && typeof item.data === "object") return item.data;

  if (typeof item?.data === "string") {
    try {
      return JSON.parse(item.data);
    } catch {
      return { imageUrl: item.data };
    }
  }

  return {};
};

const normalizeAssetUrl = (value) => {
  if (typeof value !== "string") return value;

  const markdownLink = value.trim().match(/^\[.*?\]\((https?:\/\/[^)]+)\)$/);
  return markdownLink?.[1] || value.trim();
};

const A1IMG = ({ item, allItems, handleClick, setTextOnClick, disable }) => {
  const content = getBackendContent(item);
  const actions = content?.buttons || content?.actions || [];
  const redirectItems = (allItems || []).filter(
    (entry) => entry?.uiCommand === "Redirect_Message_Payment"
  );
  const yesRedirectItem = redirectItems.find(
    (entry) => entry?.text?.trim().toLowerCase() === "yes"
  );
  const noRedirectItem = redirectItems.find(
    (entry) => entry?.text?.trim().toLowerCase() === "no"
  );

  const bannerUrl = normalizeAssetUrl(
    content?.bannerUrl ||
    content?.imageUrl ||
    content?.banner?.url ||
    content?.image?.url ||
    content?.banner ||
    content?.image ||
    item?.bannerUrl ||
    item?.imageUrl
  );

  const yesDisplayButton = getButton(
    content?.yesButton || actions[0],
    "Yes, I have a Smart TV",
    "Yes",
    item?.code
  );
  const noDisplayButton = getButton(
    content?.noButton || actions[1],
    "No",
    "No",
    item?.code
  );
  const yesButton = yesRedirectItem
    ? {
        ...getButton(yesRedirectItem, "Yes", "Yes", item?.code),
        label: yesDisplayButton.label,
      }
    : yesDisplayButton;
  const noButton = noRedirectItem
    ? {
        ...getButton(noRedirectItem, "No", "No", item?.code),
        label: noDisplayButton.label,
      }
    : noDisplayButton;

  const onAnswer = (button) => {
    if (disable) return;

    const responseLabel = button.sourceLabel || button.label;

    setTextOnClick?.(responseLabel);
    handleClick?.(
      button.code,
      button.value,
      button.tag || item?.uiCommand,
      responseLabel
    );

    if (button.tag === "Redirect_Message_Payment" && button.url) {
      window.open(button.url);
    }
  };

  return (
    <>
      <div className="a1img-message">
        <div className="chat-person a1img-message__avatar">
          <img src={chatPerson} alt="" />
        </div>

        <div className="popup-tv">
          {item?.text && (
            <div className="chat-text popup-tv__text">{item.text}</div>
          )}
          {bannerUrl && (
            <img
              className="popup-tv__banner"
              src={bannerUrl}
              alt={
                content?.imageAlt ||
                content?.bannerAlt ||
                "Set up your TV experience"
              }
            />
          )}
        </div>
      </div>

      <A1IMGPopup
        title={content?.title || "Let's set up your TV experience!"}
        question={content?.question || "Do you have a Smart TV?"}
        description={
          content?.description ||
          "Tata Play App is best experienced on a Smart TV. Once you subscribe, you can login to Tata Play app on TV and enjoy watching on both TV and mobile."
        }
        bannerUrl={bannerUrl}
        bannerAlt={
          content?.imageAlt || content?.bannerAlt || "Set up your TV experience"
        }
        yesButton={yesButton}
        noButton={noButton}
        disable={disable}
        onAnswer={onAnswer}
      />
    </>
  );
};

export default A1IMG;
